module.exports = __webpack_public_path__ + "img/d201204-2.9536f02b.jpg";